/**
 * Shown on the Documents and Frameworks tabs when the viewer is not an admin
 * of this school (ADM-8).
 */
import React from 'react';
import { View } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';

import { Card, CardContent } from '@/components/ui/card';
import { Text } from '@/components/ui/text';
import { useTranslation } from '../../../hooks/useTranslation';
import { COLORS } from '../schoolManagementTypes';

export function PrivateKnowledgeLocked() {
  const { t } = useTranslation();

  return (
    <View className="mb-6">
      <Card>
        <CardContent className="p-8 items-center">
          <MaterialIcons name="lock" size={48} color={COLORS.error} />
          <Text className="text-lg font-bold text-red-600 mt-4 mb-2">
            {t('schoolManagement.accessRequired')}
          </Text>
          <Text className="text-sm text-muted-foreground text-center">
            {t('schoolManagement.mustBeSchoolAdmin')}
          </Text>
        </CardContent>
      </Card>
    </View>
  );
}
